import React from "react";
import { Helmet } from "react-helmet";

type PropsType = {
    title: string;
};

export default function PageTitle({ title }: PropsType) {
    return (
        <Helmet>
            <title>ETK | {title}</title>
        </Helmet>
    );
}
